<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="banner-box" id="home" ref="home">
      <div class="banner-text">
        <div class="banner-br"></div>
        <div class="title">SAMORE HK LIMITED</div>
        <div class="text">
          打造卓越軟體與策略投資，共創充滿活力的未來
        </div>
      </div>
      <div class="banner-list">
        <div class="banner-item">
          <img src="../assets/banner-item-1.png" alt="" />
          <div class="item-title">軟體開發</div>
          <div class="item-content">
            提供卓越的軟體開發解決方案
          </div>
        </div>
        <div class="banner-item">
          <img src="../assets/banner-item-2.png" alt="" />
          <div class="item-title">對外投資</div>
          <div class="item-content">
            專注於策略性對外投資
          </div>
        </div>
        <div class="banner-item">
          <img src="../assets/banner-item-3.png" alt="" />
          <div class="item-title">創新引領</div>
          <div class="item-content">
            不斷引領產業創新潮流

          </div>
        </div>
        <div class="banner-item">
          <img src="../assets/banner-item-4.png" alt="" />
          <div class="item-title">未來共創</div>
          <div class="item-content">
            共同打造充滿活力的未來。
          </div>
        </div>
      </div>
    </div>
    <div class="mission-box">
      <div class="m-title">關於我們</div>
      <!-- <div class="m-subtitle">
        We develop effective plans to move
      </div> -->
      <div class="content">
        <div class="left">
          <div class="l-tit">
            致力於軟體開發
          </div>
          <div class="l-content">
            SAMORE HK LIMITED 是一家總部位於香港的公司，專注於軟體開發和策略性對外投資。 我們秉持著創新引領的理念，為客戶提供卓越的軟體解決方案，並以對外投資推動業務拓展。 公司團隊由富有經驗的專業人才組成，致力於打造未來充滿活力的產業格局。 我們以卓越的技術實力和創新意識，不斷超越自我，引領產業發展
          </div>
        </div>
        <div class="right">
          <img class="mission-img" src="../assets/mission-1.png" alt="" />
        </div>
      </div>
    </div>
    <div class="business-box">
      <div class="b-title">未來與發展</div>
      <!-- <div class="b-subtitle">
        เราหวังเป็นอย่างยิ่งว่าจะได้ให้บริการด้วยความจริงใจ 100% แก่คุณ
      </div> -->
      <div class="b-content">
        <div class="left">
          <div class="l-title">
            SAMORE HK LIMITED致力於技術創新與全球投資，以軟體開發與對外投資領域，持續拓展多元化業務。
          </div>
          <div class="l-content">
           未來，我們將持續追求卓越，與合作夥伴共同創造更廣闊的商業前景，以高效的服務和創新的解決方案推動公司邁向更輝煌的發展。
          </div>
        </div>
        <div class="right">
          <div class="item">
            <img src="../assets/service-1.png" alt="" />
            <p>軟體開發
            </p>
          </div>
          <div class="item">
            <img src="../assets/service-2.png" alt="" />
            <p>全球投資</p>
          </div>
          <div class="item">
            <img src="../assets/service-3.png" alt="" />
            <p>智慧科技</p>
          </div>
          <div class="item">
            <img src="../assets/service-4.png" alt="" />
            <p>策略諮詢</p>
          </div>
          <div class="item">
            <img src="../assets/service-5.png" alt="" />
            <p>創新解決方案</p>
          </div>
          <div class="item">
            <img src="../assets/service-6.png" alt="" />
            <p>產業領先</p>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="partner-box">
      <div class="p-title">Core team</div>
      <div class="p-subtitle">
        Currently, our core team has three directions: payment solution, user
        acquisition, and cloud software support (SAAS).
      </div>
      <div class="partner-list">
        <div class="item">
          <img src="../assets/team-1.png" alt="" />
          <div class="tit">Payment Solution Team</div>
          <div class="msg">
            Our payment security team has rich experience and professional quality. We provide fast, professional and secure one-stop payment solution services worldwide. We can also provide customers with professional overseas remote security solutions.
          </div>
        </div>
        <div class="item">
          <img src="../assets/team-2.png" alt="" />
          <div class="tit">Cloud software support (SAAS)</div>
          <div class="msg">
            refers to providing clients with services including website
            construction, mobile app development, marketing promotion, customer
            service consulting, etc., to help companies better expand overseas
            markets.
          </div>
        </div>
        <div class="item">
          <img src="../assets/team-2.png" alt="" />
          <div class="tit">User Acquisition Team</div>
          <div class="msg">
            We have a deep understanding of user acquisition and transformation:
            By understanding the user acquisition of application markets, social
            media, and mobile advertising platforms, we develop the correct
            delivery strategies for brands. Using SEO, social media, and mobile
            advertising platforms to convert user groups into brand fans.
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="deveopment-box">
      <div class="d-title">Development Goals</div>
      <div class="d-content">
        Embark on a journey of innovation with AZALEA TECH, where our
        development goal is to redefine the technological landscape. We aspire
        to be at the forefront of fearless innovation, transforming digital
        experiences globally. Our commitment extends to empowering businesses,
        leading in sustainable technology, and cultivating a diverse and
        talented team. Together, we collaborate for a global impact, creating a
        future where possibilities are limitless. Join us in shaping tomorrow's
        potential at AZALEA TECH.
      </div>
    </div> -->
    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.banner-box {
  background-image: url(../assets/swiper-1.png);
  height: 803px;
  background-size: 100% 100%;
  position: relative;

  .banner-text {
    margin-left: 360px;
    padding-top: 250px;
    width: 600px;
    .banner-br {
      width: 6px;
      height: 290px;
      background-color: #fff;
      float: left;
      margin-right: 40px;
    }
    .title {
      font-size: 64px;
      font-family: Roboto, Roboto;
      font-weight: bold;
      color: #ffffff;
      line-height: 60px;
      margin-top: 20px;
    }
    .text {
      font-size: 22px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: #ffffff;
      margin-top: 36px;
    }
  }
  .banner-list {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 379px;
    margin-top: 190px;
    .banner-item:nth-child(1) {
      background-color: #45289f;
    }
    .banner-item:nth-child(2) {
      background-color: #512da7;
    }
    .banner-item:nth-child(3) {
      background-color: #5d35b0;
    }
    .banner-item:nth-child(4) {
      background-color: #673bb7;
    }
    .banner-item {
      width: 290px;
      height: 200px;
      text-align: center;
      img {
        width: 50px;
        height: 50px;
        margin-top: 30px;
      }
      .item-title {
        font-size: 22px;
        font-family: Roboto, Roboto;
        font-weight: bold;
        color: #ffffff;
        line-height: 28px;
        margin: 10px 30px;
      }
      .item-content {
        font-size: 16px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #ffffff;
        line-height: 19px;
        margin: 0 30px;
      }
    }
  }
}
.mission-box {
  padding: 0 360px;
  height: 860px;
  overflow: hidden;
  margin-top: 100px;
  .m-title {
    margin-top: 120px;
    font-size: 58px;
    font-family: Roboto, Roboto;
    font-weight: bold;
    text-align: center;
    color: #45289f;
    margin-bottom: 90px;
  }
  .m-subtitle {
    font-size: 22px;
    font-family: Roboto, Roboto;
    font-weight: 400;
    color: rgba(51, 51, 51, 0.6);
    margin-bottom: 90px;
    text-align: center;
  }
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    font-size: 32px;
    font-family: Roboto, Roboto;
    font-weight: 600;
    color: #45289f;
    .l-tit {
      img {
        width: 24px;
        height: 24px;
        margin-left: -32px;
      }
    }
    .l-content {
      font-size: 24px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: #333333;
      margin-top: 30px;
    }
    .left {
      width: 600px;
      .mission-img {
        width: 440px;
        height: 480px;
        margin-top: 90px;
      }
    }
    .right {
      width: 40%;
      .mission-img {
        width: 500px;
        height: 470px;
      }
    }
  }
}
.user-serve-box {
  margin-top: 100px;
  background-image: url(../assets/swiper-3.png);
  height: 627px;
  overflow: hidden;
  background-size: 100% 100%;
  .title {
    font-size: 32px;
    width: 660px;
    font-family: Roboto-Bold, Roboto;
    font-weight: bold;
    color: #333333;
    text-align: left;
    margin-left: 900px;
    margin-top: 40px;
  }

  .subtitle {
    font-size: 26px;
    margin-top: 24px;
    text-align: center;
    font-weight: 500;
    color: #999999;
  }

  .server-list-box {
    margin-left: 900px;
    text-align: left;
    margin-top: 34px;
    .tit {
      font-size: 24px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #333333;
    }
    .item {
      font-size: 20px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #999999;
      margin-top: 20px;
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
}

.business-box {
  background-color: #45289f;
  height: 900px;
  overflow: hidden;
  margin-top: 100px;
  background-size: 100% 100%;
  .b-title {
    margin-top: 120px;
    margin-bottom: 60px;
    font-size: 58px;
    font-family: Roboto, Roboto;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
  .b-subtitle {
    font-size: 22px;
    font-family: Roboto, Roboto;
    font-weight: 400;
    color: #fff;
    margin-bottom: 90px;
    text-align: center;
  }
  .b-content {
    padding: 0 360px;
    display: flex;
    justify-content: space-between;
    .left {
      width: 450px;
      .l-title {
        font-size: 32px;
        font-family: Roboto, Roboto;
        font-weight: 600;
        color: #ffffff;
        line-height: 42px;
        margin-top: 38px;
      }
      .l-content {
        font-size: 24px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #ffffff;
        line-height: 32px;
      }
    }
    .right {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 700px;
      .item {
        width: 223px;
        height: 213px;
        margin-bottom: 18px;
        text-align: center;
        color: #fff;
        background: #4B2DA7;
        img {
          width: 60px;
          height: 60px;
          margin-top: 50px;
        }
        p {
          font-size: 22px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #ffffff;
          line-height: 60px;
          margin-top: 10px;
        }
      }
    }
  }
}

.partner-box {
  padding: 100px 360px;
  text-align: center;

  .p-title {
    font-size: 48px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .p-subtitle {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-top: 24px;
  }

  .partner-list {
    display: flex;
    justify-content: space-between;
    margin-top: 70px;
    .item {
      width: 300px;
      padding: 40px;
      height: 610px;
      box-shadow: 0px 32px 24px -20px rgba(223, 223, 223, 0.5);
      border-radius: 8px;
      border: 1px solid rgba(212, 240, 255, 1);
      img {
        width: 80px;
        height: 80px;
      }
      .tit {
        font-size: 24px;
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        margin: 24px 0;
      }
      .msg {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
    }
  }
}
.deveopment-box {
  padding: 0 360px;
  height: 650px;
  overflow: hidden;
  background: linear-gradient(#fde2e2, #fffbef);
  .d-title {
    font-size: 48px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    text-align: center;
    margin-top: 100px;
    margin-bottom: 24px;
  }
  .d-content {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
</style>
